import script from "./MDataTableHeaderV2.vue?vue&type=script&setup=true&lang=js"
export * from "./MDataTableHeaderV2.vue?vue&type=script&setup=true&lang=js"

import "./MDataTableHeaderV2.vue?vue&type=style&index=0&id=60312997&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60312997"]])

export default __exports__